import React from 'react'
import styles from './MicrositeMergeVariableHints.module.css'
import { Braces } from 'lucide-react'

/**
 * MicrositeMergeVariableHints
 * Clickable {{variable}} chips shown above the subject/body editors
 * in MicrositeEmailTemplateEditor — clicking inserts the variable
 * at the caret position (or appends, if onInsert doesn't manage
 * caret position itself).
 *
 * Usage:
 *   <MicrositeMergeVariableHints
 *     variables={['customerName', 'storeName', 'appointmentDate']}
 *     onInsert={(variable) => setSubject((s) => s + `{{${variable}}}`)}
 *   />
 */
const MicrositeMergeVariableHints = ({ variables = [], onInsert }) => {
    if (!variables.length) return null

    return (
        <div className={styles.wrap}>
            <span className={styles.label}>
                <Braces size={12} />
                Available variables:
            </span>
            {variables.map((v) => (
                <button
                    key={v}
                    type="button"
                    className={styles.chip}
                    onClick={() => onInsert?.(v)}
                    title={`Click to insert {{${v}}}`}
                >
                    {`{{${v}}}`}
                </button>
            ))}
        </div>
    )
}

export default MicrositeMergeVariableHints